import React, { useEffect, useState } from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, Cell, ResponsiveContainer, ReferenceLine } from "recharts";
import { adminApi } from "../../../lib/api";

const shortDate = (d) =>
  d ? new Date(d).toLocaleDateString("en-GB", { day: "numeric", month: "short", timeZone: "Europe/London" }) : "—";

const money = (v) => `${v < 0 ? "−" : ""}£${Math.abs(Number(v)).toFixed(0)}`;

export const ProfitTrendChart = () => {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    adminApi.get("/admin/market-review/history")
      .then((r) => setRows(r.data.slice(0, 8).reverse().map((h) => ({ date: shortDate(h.delivery_date), profit: h.profit_loss }))))
      .catch(() => setRows([]));
  }, []);

  if (rows === null) return null;

  return (
    <div data-testid="profit-trend-chart" className="bg-white rounded-lg border border-gray-200 p-5 shadow-sm">
      <h3 className="font-bold text-[#0A1F13]">Profit trend</h3>
      <p className="text-sm text-gray-500 mb-4">Profit / loss for your last {rows.length || ""} reviewed market days</p>
      {rows.length === 0 ? (
        <p data-testid="profit-trend-empty" className="text-sm text-gray-400 py-8 text-center">Save a Market Review to start seeing your profit trend.</p>
      ) : (
        <div className="h-64">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={rows} margin={{ top: 5, right: 10, left: 0, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#eee" />
              <XAxis dataKey="date" tick={{ fontSize: 12 }} />
              <YAxis tickFormatter={money} tick={{ fontSize: 12 }} width={60} />
              <Tooltip formatter={(v) => [`${v < 0 ? "−" : ""}£${Math.abs(Number(v)).toFixed(2)}`, "Profit"]} />
              <ReferenceLine y={0} stroke="#999" />
              <Bar dataKey="profit" radius={[4, 4, 0, 0]}>
                {rows.map((r, i) => <Cell key={i} fill={r.profit >= 0 ? "#228B22" : "#DC2626"} />)}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
};
